import { BreakpointObserver } from '@angular/cdk/layout';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatStepper } from '@angular/material/stepper';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { combineLatest, Observable, of, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ChannelType } from 'src/app/enums/channel-type.enum';
import { BusinessUserResource } from 'src/app/interfaces/business-user-resource';
import { ContactChannelResource } from 'src/app/interfaces/contactchannel';
import { ContractResource } from 'src/app/interfaces/contract-resource';
import { PagedResources } from 'src/app/interfaces/paged-resources';
import { BusinessuserService } from 'src/app/services/businessuser.service';
import { OverlayService } from 'src/app/services/overlay.service';

@Component({
  selector: 'app-edit',
  templateUrl: './edit.component.html',
  styleUrls: ['./edit.component.scss']
})
export class EditComponentBusinessuserAdmin implements OnInit {
  @ViewChild('stepper') stepper: MatStepper;
  selected = -1;
  page = null;
  pageComponents = {
    pageIndex: 0,
    pageSize: 8
  }
  stepperOrientation: Observable<any>;
  currentBusinessUserResource: BusinessUserResource = null;
  selectedBusinessuser: boolean = false;
  contactFormChanged: boolean = false;
  currentmembers: BusinessUserResource[] = [];
  head: BusinessUserResource;
  isHead: boolean = true;
  public genderOptions = [
    { value: 'MALE', viewValue: 'Herr' },
    { value: 'FEMALE', viewValue: 'Frau' },
    { value: 'UNDEFINED', viewValue: 'Divers' },
  ]

  public contactChannelOptions = [
    { value: 'EMAIL', viewValue: 'Mail', state: true },
    { value: 'PHONE_PRIVATE', viewValue: 'Telefon', state: false },
    { value: 'PHONE_MOBILE', viewValue: 'Telefon (Mobil)', state: false },
    { value: 'FAX', viewValue: 'Fax', state: false },
    { value: 'WEBSITE', viewValue: 'Webseite', state: false },
    { value: 'UNKNOWN', viewValue: 'Andere', state: false },
  ];

  public contactChannelTypes = [
    { value: 'NEW', viewValue: 'Neu/Ungeprüft', state: false },
    { value: 'VALIDATION', viewValue: 'In Prüfung', state: false },
    { value: 'VALID', viewValue: 'Geprüft', state: false },
    { value: 'INVALID', viewValue: 'Ungültig', state: false }
  ]

  public roles = [
    { value: "ROLE_ADMIN", viewValue: "Administrator" },
    { value: "ROLE_CASEWORKER", viewValue: "Sachbearbeiter" },
    { value: "ROLE_SERVICE", viewValue: "Webservice" },
    { value: "ROLE_PARTNER", viewValue: "Aktionspartner" },
    { value: "ROLE_CUSTOMER", viewValue: "Kunde" },
    { value: "ROLE_PRE_CUSTOMER", viewValue: "Vorkunde" },
    { value: "ROLE_ANON", viewValue: "Anonymous" },
  ]


  finishedLoadingUsers: boolean = false;
  addForm: UntypedFormGroup;
  addressForm: UntypedFormGroup;
  accountForm: UntypedFormGroup;
  contactForm: UntypedFormGroup;
  membersForm: UntypedFormGroup;
  dataSource: MatTableDataSource<BusinessUserResource>;
  contactChannelsArray: ContractResource[] = []
  // 'number',
  displayedColumns = ['menu', 'user'];
  constructor(
    private fb: UntypedFormBuilder,
    private businessuserService: BusinessuserService,
    private breakpointObserver: BreakpointObserver,
    private route: ActivatedRoute,
    private router: Router,
    private overlay: OverlayService) {
    this.addForm = this.fb.group({
      autoActivation: ['']
    })

    this.contactForm = this.fb.group({
      contactChannels: this.fb.array([]),
    })

    this.accountForm = this.fb.group({
      username: ['', [Validators.required, Validators.email]],
      customerNumber: [''],
      gender: ['', [Validators.required]],
      title: [''],
      firstName: ['', [Validators.required]],
      lastName: ['', [Validators.required]],
      birthday: ['', [Validators.required]],
      phone: ['', []],
      email: ['', [Validators.email]],
      created: ['', []],
      lastModified: ['', []],
      role: ['', []]
    })

    this.addressForm = this.fb.group({
      street: ['', [Validators.required]],
      postcode: ['', [Validators.required]],
      city: ['', [Validators.required]],
    })

    this.membersForm = this.fb.group({
      members: this.fb.array([])
    })

    //change the orientation of the stepper based on th screen with
    this.stepperOrientation = this.breakpointObserver
      .observe('(min-width: 800px)')
      .pipe(map(({ matches }) => (matches ? 'horizontal' : 'vertical')));
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      combineLatest([
        this.businessuserService.getBuissnessUserAdmin(params['id']),
        // this.businessuserService.getGroupHead(params['id']).pipe(catchError(err => of(err))),
      ]).pipe(
        map(([user]: (any)) => {
          // console.log(user,head)
          this.currentBusinessUserResource = user;
          this.currentBusinessUserResource = user;
          // if (head !instanceof HttpErrorResponse) {

          // }else{
          //   this.head = head;
          //   if (this.head.publicId == this.currentBusinessUserResource.publicId) {
          //     this.isHead = true;
          //   } else {
          //     this.isHead = false;
          //     this.addressForm.disable();
          //   }
          // }


          this.accountForm.patchValue({
            customerNumber: user.customerNumber,
            title: user.person?.title,
            firstName: user.person?.firstName,
            lastName: user.person?.lastName,
            birthday: user.person?.birthday,
            gender: user.person?.gender,
            phone: user?.phone,
            email: user?.email,
            username: user.account.username,
            created: this.formatDate(user.account?.created),
            lastModified: this.formatDate(user.account?.lastModified),
            role: user.account.role.name

          })

          this.accountForm.controls.created.disable();
          this.accountForm.controls.lastModified.disable();
          if(user.account.role.name == 'ROLE_CASEWORKER'){
            this.accountForm.controls.username.disable();
            this.accountForm.controls.customerNumber.disable();
          }
          //
          //this.accountForm.controls.role.disable();
          //this.accountForm.controls.customerNumber.disable();

          this.addressForm.patchValue({
            street: user.address?.street,
            postcode: user.address?.postcode,
            city: user.address?.city,
          })



        })).subscribe(
          result => {
            this.finishedLoadingUsers = true;
          },
          error => {
            console.log("error: ", error);
            this.overlay.openErrorDialog("Fehler beim Laden", "Versuchen Sie es bitte später noch einmal. Sollte das Problem nicht in absehbarer Zeit behoben sein, schreiben Sie uns eine E-Mail an: support@plusservices.de", "Zurück")
          }
        );
    })

    this.contactForm.statusChanges.subscribe(result => {
      this.contactFormChanged = true;
    });
  }


  getActiveType() {
    let t = []
    this.contactChannelsArray.forEach((element1: any) => {
      t.push(element1.channelType);
    })
    return t;
  }

  changeAvalibleContactChannels(event: any) {
    console.log(1)
    // this.contactChannelOptions.forEach(element => {
    //   if (element.value == event.value) {
    //     element.state = true;
    //   }
    // });
  }



  editUser() {
    this.currentBusinessUserResource.customerNumber = this.accountForm.value.customerNumber;
    this.currentBusinessUserResource.person.firstName = this.accountForm.value.firstName;
    this.currentBusinessUserResource.person.lastName = this.accountForm.value.lastName;
    this.currentBusinessUserResource.person.birthday = this.accountForm.value.birthday;
    this.currentBusinessUserResource.person.gender = this.accountForm.value.gender;
    this.currentBusinessUserResource.person.title = this.accountForm.value.title;
    this.currentBusinessUserResource.phone = this.accountForm.value.phone;
    this.currentBusinessUserResource.mobile = this.accountForm.value.phone;
    this.currentBusinessUserResource.email = this.accountForm.value.email;
    this.currentBusinessUserResource.account.role.name = this.accountForm.value.role;
    this.roles.forEach(element => {
      if (element.value == this.accountForm.value.role) {
        this.currentBusinessUserResource.account.role.displayName = element.viewValue;
      }
    });
    if (this.currentBusinessUserResource.address != null) {
      this.currentBusinessUserResource.address.street = this.addressForm.value.street;
      this.currentBusinessUserResource.address.city = this.addressForm.value.city;
      this.currentBusinessUserResource.address.postcode = this.addressForm.value.postcode;
    } else {
      let tempAddress = {
        city: null,
        postcode: null,
        street: null,
        countryCode: 'DE',
        location: {
          lat: null,
          lng: null
        }
      }
      this.currentBusinessUserResource.address = tempAddress;
      this.currentBusinessUserResource.address.street = this.addressForm.value.street;
      this.currentBusinessUserResource.address.city = this.addressForm.value.city;
      this.currentBusinessUserResource.address.postcode = this.addressForm.value.postcode;

    }
    this.businessuserService.editBuissnessUser(this.currentBusinessUserResource).subscribe(value => {
      console.log("VALUE FORM EDIT", value);
      this.overlay.openSnackBar("Account erfolgreich bearbeitet!")
    })

  }

  private formatDate(date) {
    const d = new Date(date);
    let month = '' + (d.getMonth() + 1);
    let day = '' + d.getDate();
    const year = d.getFullYear();
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return [year, month, day].join('-');
  }

  /**
 * Get the contactForm contactChannels as an UntypedFormArray
 */
  get contactChannels(): UntypedFormArray {
    return this.contactForm.controls["contactChannels"] as UntypedFormArray;
  }
  /**
* Delte a ContactChannel
* @param lessonIndex 
*/
  deletContactChannels(lessonIndex: number) {
    if (this.contactChannels.value[lessonIndex].channelData != '' && this.contactChannels.value[lessonIndex].publicId != '') {
      this.businessuserService.delteContactChannel(this.currentBusinessUserResource.publicId, this.contactChannels.value[lessonIndex]).subscribe(value => {
        this.currentBusinessUserResource = value;
        this.contactChannels.removeAt(lessonIndex);
        this.overlay.openSnackBar("Kontakt erfolgreich gelöscht")
      })
    } else {
      this.contactChannels.removeAt(lessonIndex);
    }
  }
  /**
   * Edit the Channels of the User
   * @returns 
   */
  editContactChannels() {
    this.contactForm.markAllAsTouched();
    if (this.contactForm.invalid) {
      return;
    }
    this.contactForm.getRawValue().contactChannels.forEach((channel: ContactChannelResource, index) => {
      if (channel.publicId) {
        if (channel.channelType == ChannelType.EMAIL) {
          this.businessuserService.updateMailChannel(this.currentBusinessUserResource.publicId, channel, false).subscribe(value => {
            this.overlay.openSnackBar("Kontakt erfolgreich bearbeitet (MAIL)")
          })
        } else {
          this.businessuserService.updateContactChannel(this.currentBusinessUserResource.publicId, channel).subscribe(value => {
            this.overlay.openSnackBar("Kontakt erfolgreich bearbeitet")
          })
        }

      } else {
        if (channel.channelData != "") {
          this.businessuserService.createContactChannel(this.currentBusinessUserResource.publicId, channel).subscribe((value: ContactChannelResource) => {
            this.addContactChannelsWithValue(value.channelType, value.channelData, value.channelState, value.publicId);
            this.contactChannels.removeAt(index);
            this.contactForm.value.contactChannels.re
            this.overlay.openSnackBar("Kontakt erfolgreich angelegt")
          })
        }
      }
    });
  }

  /**
 * Add a new Form to add a ContractChannel and patch the passed Data
 * @param type 
 * @param data 
 * @param state 
 * @param publicId 
 */
  addContactChannelsWithValue(type, data, state, publicId) {
    const contactChannelForm = this.fb.group({
      channelType: [type, Validators.required],
      channelData: [data, Validators.required],
      channelState: [state, Validators.required],
      publicId: [publicId],
    });

    this.contactChannels.push(contactChannelForm);
    /**
     * Cant Edit mails 
     */
    if (type == ChannelType.EMAIL) {
      contactChannelForm.controls.channelType.disable();
    }
  }
  /**
* Add a new Form to add a ContractChannel
*/
  addContactChannels() {
    const contactChannelForm = this.fb.group({
      channelType: ['', Validators.required],
      channelData: ['', Validators.required],
      channelState: ['NEW', Validators.required],
    });
    this.contactChannels.push(contactChannelForm);
  }
}
